module.exports = __webpack_public_path__ + "media/images/products/retailers-og-1-16e58d9991d2a203e6bd164d806bdda8.jpg";